import deLabels from "react-phone-number-input/locale/de.json";
import enLabels from "react-phone-number-input/locale/en.json";
import esLabels from "react-phone-number-input/locale/es.json";
import frLabels from "react-phone-number-input/locale/fr.json";
import itLabels from "react-phone-number-input/locale/it.json";
import ptLabels from "react-phone-number-input/locale/pt.json";

import { Language, toLanguage } from "../../../services/i18ln/languages";

const LABELS: Record<Language, typeof enLabels> = {
  pt: ptLabels,
  en: enLabels,
  es: esLabels,
  fr: frLabels,
  de: deLabels,
  it: itLabels,
};

/** The country names of the phone field in the editor's language (English for one it doesn't have). */
export const countryLabels = (language: string) => LABELS[toLanguage(language)];
